import React from 'react'
import { useTranslation } from 'react-i18next'
import Loader from 'components/common/Loader'
import c from './LoaderSlide.module.scss'

interface LoaderSlideProps {
  index: number
}

function LoaderSlide({ index }: LoaderSlideProps) {
  const { t } = useTranslation()

  return (
    <div className={c.loaderWrapper}>
      <Loader />
      <p className={c.loaderText}>
        {t('stages.generation.finish.loaderText', { index: index + 1 })}
      </p>
    </div>
  )
}

export default LoaderSlide
